import script from "./pagination.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./pagination.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./pagination.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__